import { sis_tokhoi } from "../models/response/to-khoi/sis_tokhoi";
import { BaseCRUDApi } from "./baseCRUDApi";

export const API_TO_KHOI_PATH = "to-khoi"

class ToKhoiApi extends BaseCRUDApi<sis_tokhoi> {
    constructor({ path }: { path: string; }) {
        super(path);
    }
}
export const toKhoiApi = new ToKhoiApi({ path: API_TO_KHOI_PATH });

